import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HomeDashboardService } from '../../data/services/view/home-dashboard.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';

@Component({
  selector: 'app-new-leases',
  templateUrl: './new-leases.component.html',
  styleUrls: ['./new-leases.component.scss'],
})
export class NewLeasesComponent implements OnInit {
  data: any;
  options: any;
  platformId = inject(PLATFORM_ID);

  constructor(
    private readonly dashboardService: HomeDashboardService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadChartData();
  }

  loadChartData() {
    this.dashboardService.newLeases().subscribe((response) => {
      if (isPlatformBrowser(this.platformId)) {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--p-text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
        const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

        const monthNames = Object.keys(response.data); // Obtener los nombres de los meses dinámicamente
        const leaseCounts = monthNames.map(month => response.data[month].length); // Contar arrendamientos por mes

        this.data = {
          labels: monthNames,
          datasets: [
            {
              type: 'line',
              label: 'Arrendamientos Nuevos',
              borderColor: '#42A5F5',
              backgroundColor: 'rgba(66, 165, 245, 0.2)',
              borderWidth: 3,
              fill: true,
              tension: 0.4,
              data: leaseCounts
            }
          ]
        };

        this.options = {
          maintainAspectRatio: false,
          aspectRatio: 0.6,
          plugins: {
            legend: {
              labels: {
                color: textColor
              }
            }
          },
          scales: {
            x: {
              ticks: {
                color: textColorSecondary
              },
              grid: {
                color: surfaceBorder
              }
            },
            y: {
              beginAtZero: true,
              ticks: {
                color: textColorSecondary
              },
              grid: {
                color: surfaceBorder
              }
            }
          }
        };

        this.cd.markForCheck();
      }
    });
  }
}
